import { RequestListingPage } from "@/components/request-listing-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/marketplace/request/$listingId/$variantId")({
  component: Component,
});

function Component() {
  const { listingId, variantId } = Route.useParams();

  return <RequestListingPage listingId={listingId} variantId={variantId} />;
}
